<template>
  <div class="chart-container container-tbd-chart" v-bind:style="{ width: options.width + 'px' }">
    <p v-if="isNoData" style="text-align: center;">NO DATA</p>
    <div v-else>
      <table
        ref="chart"
        class="stripe hover"
        :class="{ 'selectable' : options.selectable }"
        width="100%"
      ></table>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import dt from 'datatables.net-dt';
import dtFixColum from 'datatables.net-fixedcolumns-dt';
import dtFixHeader from 'datatables.net-fixedheader-dt';
import dtButton from 'datatables.net-buttons/js/buttons.html5';

export default {
  props: {
    data: {
      type: String
    },
    chartOptions: {
      type: Object
    }
  },
  data () {
    return {
      options: {
        width: null,
        decimal: 1,
        paging: true,
        allowSearch: true,
        pageLength: 10,
        showInfo: false,
        selectable: false,
        csvDownload: false,
        dataObj: {}
      },
      isNoData: true,
      table: null
    };
  },
  watch: {
    data: function () {
      if (this.data) {
        this.dataObj = JSON.parse(this.data);
      } else {
        this.dataObj = {
          data: [],
          columns: []
        };
      }
      this.render();
    },
    chartOptions: function () {
      if (this.chartOptions) {
        this.render();
      }
    }
  },
  mounted () {
    this.render();
  },
  methods: {
    // setNoDataText: function () {
    //   this.$refs.chart.innerHTML = '<p style="text-align: center;">NO DATA</p>';
    // },
    getColumns: function (rawColumns) {
      const result = [];
      const alignClassMapping = {
        left: 'dt-body-left',
        center: 'dt-body-center',
        right: 'dt-body-right'
      };
      rawColumns.forEach((col) => {
        const dtCol = {
          title: col.name,
          type: col.type,
          width: col.width
        };
        if (col.data !== undefined) { dtCol.data = col.data; }
        if (col.align !== undefined) {
          dtCol.className = alignClassMapping[col.align];
        }
        if (col.orderable !== undefined) {
          dtCol.orderable = col.orderable;
        }
        if (col.render !== undefined) {
          dtCol.render = col.render;
        }
        if (col.type === 'number') {
          // dtCol.render = col.format ? $.fn.dataTable.render.number(',', '.', this.options.decimal, '') : undefined;
          if (col.format) {
            const usedDecimal = col.decimal !== undefined ? col.decimal : this.options.decimal;
            dtCol.render = $.fn.dataTable.render.number(
              ',',
              '.',
              usedDecimal,
              ''
            );
            dtCol.type = 'num-fmt';
          }
          dtCol.className = 'dt-body-right';
        }
        result.push(dtCol);
      });
      return result;
    },
    render: function () {
      if (this.chartOptions) Object.assign(this.options, this.chartOptions);
      if (this.data && !this.dataObj) {
        this.dataObj = JSON.parse(this.data);
      }
      // if (!this.dataObj) {
      //   // this.setNoDataText();
      //   return;
      // }
      const data = this.dataObj;
      let columns = [];
      if (!data.data || data.data.length === 0 || !data.columns || data.columns.length === 0) {
        // this.setNoDataText();
        this.isNoData = true;
        return;
      }
      this.isNoData = false;

      columns = this.getColumns(data.columns);

      const buttonsOptions = this.options.csvDownload ? [{ extend: 'csv', text: 'Download' }] : [];

      setTimeout(() => {
        if (this.table) {
          this.table.destroy();
        }
        const $chart = $(this.$refs.chart);
        this.table = $chart.DataTable({
          retrieve: true,
          data: data.data,
          order: [],
          paging: this.options.paging,
          pageLength: this.options.pageLength,
          columns: columns,
          searching: (this.options.allowSearch || (!!data.allowSearch)),
          info: this.options.showInfo,
          scrollX: true,
          fixedColumns: data.fixedColumns ? JSON.parse(data.fixedColumns) : false, // { leftColumns: 1}

          dom: 'Bfrtip',
          buttons: buttonsOptions,
          columnDefs: data.columnDefs ? data.columnDefs : []
        });

        if (this.options.selectable === true) {
          const $rows = $chart.find('tbody tr');
          const selectedClassName = 'selected';
          $rows.on('click', (event) => {
            $rows.removeClass(selectedClassName);
            $(event.currentTarget).addClass(selectedClassName);
            const data = this.table.row(event.currentTarget).data();
            this.$emit('rowClick', data);
          });
        }
      }, 250); // Waiting for HTML rendering
    }
  }
};
</script>

<style>
@import '../../node_modules/datatables.net-dt/css/jquery.dataTables.css';
@import '../../node_modules/datatables.net-buttons-dt/css/buttons.dataTables.css';
@import '../../node_modules/datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.css';
</style>

<style lang="scss">
.chart-container {
  font-size: 12px;
  font-family: system-ui;
  .dataTable {
    &.selectable {
      tr {
        cursor: pointer;
      }
    }
  }
}
</style>
